import React, {useState} from 'react';
import {withTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Box, IconButton, List, ListItem, ListItemText,} from '@mui/material';
import {useAuth} from "../../context/auth-context";
import SaveRouteListItemComponent from "./SaveRouteListItemComponent";
import Constants from "../../config/constants";
import useStoredRouteClear from "../../hooks/useStoredRouteClear";
import {MuiButton} from "../MuiButton";
import {toast} from "react-toastify";
import {compose} from "redux";
import {connect} from "react-redux";

const SaveRouteListComponent = ({i18n, t, onClose, customerRoutes, user, isOnline}) => {
    const auth = useAuth();
    const [askDelete, setAskDelete] = useState(false);
    const {mutateAsync, status, error } = useStoredRouteClear(i18n.language);

    const multipitchRoutes = customerRoutes.filter((route) => route.type === Constants.MULTIPITCH).sort(function(a, b) {
        return a.label.localeCompare(b.label);
    });

    const cliffRoutes = customerRoutes.filter((route) => route.type === Constants.CLIFF).sort(function(a, b) {
        return a.label.localeCompare(b.label);
    });

    const clearAllRoutes = async () => {
        try {
            await mutateAsync(i18n.language);
        } catch (e) {
            console.error(e);
            toast.error(t('common.error.delete'));
        }
    }

    return (<>
        {customerRoutes.length > 0 && <List component="div" disablePadding>
            <List>
                <ListItem
                    secondaryAction={<>
                        {(status === "success" || status === "idle") && !askDelete && isOnline && <IconButton edge="end"
                                                                                                              aria-label="delete"
                                                                                                              id={'askClearAllButton'}
                                                                                                              onClick={() => setAskDelete(true)}>
                            <FontAwesomeIcon icon={["fas", "trash"]} size="sm" className="text-danger" />
                        </IconButton>}
                        {(status === "success") && askDelete && <>

                        </>}
                        {status === "pending" && <IconButton edge="end" aria-label="loading">
                            <FontAwesomeIcon icon={["fas", "spinner"]} size="sm" spin className="secondary" />
                        </IconButton>}
                        {status === "error" && <IconButton edge="end" aria-label="error">
                            <FontAwesomeIcon icon={["fas", "exclamation-triangle"]} size="sm" className={"text-danger"} />
                        </IconButton>}
                    </>}>
                <ListItemText primary={<span>{t("Navbar.saveRoute.clearAll")}</span>}
                               secondary={askDelete ? <>
                                       <p style={{margin: "0.5rem 0"}}>{t("Navbar.saveRoute.delete.confirmAll")}</p>
                                       <Box display="flex" alignItems="flex-start" style={{textAlign: "left"}}>
                                           <Box flexGrow={1}>
                                               <MuiButton variant="contained"
                                                          color="gray"
                                                          edge="start"
                                                          aria-label="delete"
                                                          id={'cancelClearAllStoreRouteButton'}
                                                          onClick={() => setAskDelete(false)}>
                                                   {t("common.cancel")}
                                                   {/*<FontAwesomeIcon icon={["fas", "times"]} size="sm" />*/}
                                               </MuiButton>
                                           </Box>
                                           <Box flexGrow={1}>
                                               <MuiButton variant="contained"
                                                          color="primary"
                                                          edge="end"
                                                          id={'clearAllStoreRouteButton'}
                                                          aria-label="delete"
                                                          onClick={(e) => {e.preventDefault(); clearAllRoutes();}}>
                                                   {t("common.confirm")}
                                                   {/*<FontAwesomeIcon icon={["fas", "check"]} size="sm" />*/}
                                               </MuiButton>
                                           </Box>
                                       </Box>
                                   </>
                                   : null } />
                </ListItem>
            </List>

            {/*Showing saveroute item while deleting them is not a good idea */}
            {status !== "pending" && multipitchRoutes.length > 0 && <>
                {/*<ListSubheader disableSticky className={"storeRouteHeader"}>{t("Navbar.saveRoute.multipitch")}</ListSubheader>*/}
                {multipitchRoutes.map((multipitchRoute) => {
                    return (<SaveRouteListItemComponent user={user}
                                                        saveRoute={multipitchRoute}
                                                        isOnline={isOnline}
                                                        key={multipitchRoute.route.id + '-' + multipitchRoute.endValidationDate } onClose={onClose}/>);
                })}
            </>}
            {status !== "pending" && cliffRoutes.length > 0 && <>
                {/*<ListSubheader disableSticky className={"storeRouteHeader"}>{t("Navbar.saveRoute.cliff")}</ListSubheader>*/}
                {cliffRoutes.map((cliffRoute) => {
                    return (<SaveRouteListItemComponent user={user}
                                                        saveRoute={cliffRoute} key={cliffRoute.route.id + '-' + cliffRoute.endValidationDate }
                                                        isOnline={isOnline}
                                                        onClose={onClose}/>);
                })}
            </>}
        </List>}
        {!auth.isAuthenticated && <List component="div" disablePadding>
            <ListItem>
                <ListItemText primary={t("Navbar.saveRoute.guest")} />
            </ListItem>
        </List>}
        {auth.isAuthenticated && customerRoutes.length === 0 && <List component="div" disablePadding>
            <ListItem>
                <ListItemText  className={"text-danger"} primary={t("Navbar.saveRoute.empty")} />
            </ListItem>
        </List>}
    </>);
};

const mapStateToProps = (state) => {
    return {
        isOnline: state.common.isOnline,
    }
};

export default
compose(
    withTranslation(),
    connect(
        mapStateToProps,
        null
    ))(SaveRouteListComponent);